import styled, {keyframes} from 'styled-components';

import {colors} from 'theme';

const rotateKeyframe = keyframes`
    to {
        transform: rotate(360deg);
    }
`;

const sizeMap: Record<number, string> = {
    1: '25px',
    2: '35px',
    3: '50px',
    4: '70px',
    5: '100px',
};
const size = (p: {size?: number}) => sizeMap[p.size ?? 1];

export const Spinner = styled.span<{
    size?: number;
    color?: 'current' | 'primary';
}>`
    display: inline-block;
    vertical-align: top;
    width: ${size};
    height: ${size};
    border-radius: 50%;
    border-width: 2px;
    border-style: solid;
    border-color: ${({color}) => {
        switch (color) {
            case 'current':
                return 'currentColor';
            case 'primary':
            default:
                return colors.brandPrimary;
        }
    }};
    border-left-color: transparent;
    animation: ${rotateKeyframe} 0.8s ease infinite;
`;
